/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

const space050 = token('space.050');
const space100 = token('space.100');
const space150 = token('space.150');
const space300 = token('space.300');

export const FinishReviewPopup = styled.div({
  width: '324px',
  display: 'flex',
  flexDirection: 'column',
  padding: `${space300} ${space300} ${space300} ${space300}`,
  alignItems: 'flex-start',
  gap: space050,
});

export const StatusOption = styled.div({
  paddingTop: space050,
  gap: space050,
});

export const PopupTitle = styled.h3({
  marginBottom: space150,
});

export const OutdatedTitle = styled.div({
  display: 'flex',
  alignItems: 'center',
  gap: space100,
});
